import { useCallback } from 'react'

import { useAccount, usePublicClient } from 'wagmi'

import { Hash } from 'types/entities'

import { useRequest } from 'hooks/api'
import { useNativeCurrency } from 'hooks/token/index'

import { errors } from 'constants/errors'
import { fetchToken } from 'services/fetchTokens'
import { isEther, checkIsAddress } from 'utils/crypto'

import { useAssetBalance } from './useAssetBalance'

export function useToken() {
  const { address } = useAccount()
  const { chain } = usePublicClient()

  const nativeCurrency = useNativeCurrency()

  const getBalance = useAssetBalance()
  const handleTokenMetadata = useCallback(
    async (token: Hash) => {
      checkIsAddress(token)

      if (!address) {
        throw new Error(errors.wallet.WALLET_REQUIRED)
      }

      if (isEther(token)) {
        const balance = await getBalance(token)

        return { ...nativeCurrency, balance }
      }
      return await fetchToken(token, address, chain)
    },
    [chain, address, nativeCurrency, getBalance],
  )

  return useRequest(handleTokenMetadata)
}
